module.exports = __webpack_public_path__ + "static/media/audio.fc630db4.wav";